import { j as t } from "./index58.mjs";
import { Popover as a } from "@mantine/core";
import { useMemo as m } from "react";
import { ActionIcon as n } from "./index20.mjs";
import { Tooltip as x } from "./index17.mjs";
import y from "./index102.mjs";
const c = [
  { emoji: "❤️", type: "heart" },
  { emoji: "🔥", type: "fire" },
  { emoji: "🎉", type: "party" },
  { emoji: "😭", type: "cry" },
  { emoji: "😂", type: "laugh" },
  { emoji: "👍", type: "thumbs-up" },
  { emoji: "👎", type: "thumbs-down" }
], b = ({
  value: r,
  reactions: p = [],
  onEmojiClick: d
}) => {
  const l = m(() => {
    const e = [];
    return p.forEach((o) => {
      const s = e.findIndex((i) => i.type === o.type);
      s === -1 ? e.push({ type: o.type, count: 1 }) : e[s].count += 1;
    }), e;
  }, [r]);
  return /* @__PURE__ */ t.jsxs("div", { className: "flex items-center gap-2", children: [
    l.map((e) => {
      var o;
      return /* @__PURE__ */ t.jsx(
        x,
        {
          label: /* @__PURE__ */ t.jsxs("div", { className: "flex flex-col gap-0.5", children: [
            p.filter((s) => s.type === e.type).map((s) => {
              var i;
              return /* @__PURE__ */ t.jsx("p", { className: "text-xs m-0", children: (i = s.user) == null ? void 0 : i.displayName }, s.userId);
            }).slice(0, 3),
            p.length > 3 && /* @__PURE__ */ t.jsxs("p", { className: "text-xs m-0", children: [
              "+",
              e.count - 3,
              " more"
            ] })
          ] }),
          children: /* @__PURE__ */ t.jsxs(
            n,
            {
              "data-testid": `reaction-${e.type}`,
              className: "flex items-center w-fit px-3",
              variant: e.type === (r == null ? void 0 : r.type) ? "light" : "outline",
              color: e.type === (r == null ? void 0 : r.type) ? "primary" : "dark",
              radius: "lg",
              onClick: () => d({
                emoji: c.find((s) => s.type === e.type).emoji,
                type: e.type
              }),
              children: [
                /* @__PURE__ */ t.jsx("div", { className: "flex -gap-1 mr-2", children: (o = c.find((s) => s.type === e.type)) == null ? void 0 : o.emoji }),
                /* @__PURE__ */ t.jsx("span", { className: "font-medium text-xs text-primary-300", children: e.count })
              ]
            }
          )
        },
        e.type
      );
    }),
    /* @__PURE__ */ t.jsxs(a, { position: "bottom-start", children: [
      /* @__PURE__ */ t.jsx(a.Target, { children: /* @__PURE__ */ t.jsx(
        n,
        {
          "data-testid": "reaction-add",
          className: "w-10",
          variant: "outline",
          radius: "lg",
          children: /* @__PURE__ */ t.jsx(y, { className: "w-4 h-4" })
        }
      ) }),
      /* @__PURE__ */ t.jsx(a.Dropdown, { children: /* @__PURE__ */ t.jsx("div", { className: "flex items-center gap-1", children: c.map((e) => /* @__PURE__ */ t.jsx(
        n,
        {
          variant: "subtle",
          color: "dark",
          radius: "lg",
          className: "pt-2 hover:scale-125 transition",
          "data-testid": `emoji-${e.type}`,
          onClick: () => d(e),
          children: e.emoji
        },
        e.type
      )) }) })
    ] })
  ] });
};
export {
  b as EmojiSelect
};
